module.exports = __webpack_public_path__ + "img/logo-small.f4c2a043.png";